export default __webpack_public_path__ + "static/media/10.ff7c3b7c.jpg";